import React from 'react'
import VoteButton from './VoteButton';

export default function Vote1(props) {
    const { themeData } = props;

    const handleStatus = () => {
        switch (themeData.win){
            case "none": return (themeData && themeData.type === "end" ? "vote-end" : "");
            case "16cha": return "winner-16cha";
            case "calpis": return "winner-calpis";
            case "same": return "draw";
            default: return "";
        }
    }

    return (<>
        <div className="round round1"></div>
        <div className="vote-title title1"></div>
        <div className="vote-desc">
            <div>你有兩則中秋烤肉邀請!</div>
            <div>老媽叫你回家團聚，與最麻吉的好友約你聚聚，你決定....?</div>
        </div>
        <div className={`vote-bg round1 ${handleStatus()}`}></div>
        <div className="vote-chat-container">
            <div className="vote-chat cha">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#親情先決</div>
                        <div className="desc">老媽買的十六茶，像爺爺泡的茶，有種味道叫家!回家團聚溫馨烤，享受天然茶湯與家人天然的愛!</div>
                    </div>
                    <VoteButton voteType="cha" week="1">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
            <div className="vote-chat calpis">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#友情無價</div>
                        <div className="desc">嘻嘻哈哈講些傻話，為了蛤蜊有沒有開吵架，再來瓶「可爾必思」，中秋就和朋友歡樂烤，享受青春!</div>
                    </div>
                    <VoteButton voteType="calpis" week="1">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
        </div>
    </>)
}